module.exports = __webpack_public_path__ + "img/access.8ece52cf.png";